import { SectionHeading } from "@/components/SectionHeading";
import { RevealGroup, RevealItem } from "@/components/Reveal";
import { Icon } from "@/components/Icon";
import { whyUs, IMG } from "@/data/content";

export default function WhyUs() {
  return (
    <section className="bg-white py-24 lg:py-32" data-testid="why-us">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading
          eyebrow="Why HM Services"
          title="Why Choose HM Services?"
          subtitle="A hospitality-focused partner that understands your property and how today's guests search and book."
        />

        <div className="mt-16 grid gap-6 lg:grid-cols-3">
          {/* Feature image tile spanning two rows */}
          <RevealItem className="relative overflow-hidden rounded-3xl lg:row-span-2">
            <div className="group relative h-64 w-full lg:h-full">
              <img src={IMG.reception} alt="Elegant hotel reception" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-navy/90 via-navy/30 to-transparent" />
              <div className="absolute bottom-0 p-8">
                <p className="font-serif text-2xl font-semibold text-white">Built for hospitality.</p>
                <p className="mt-2 text-sm text-white/75">Not a generic web agency — a consultancy that speaks your language.</p>
              </div>
            </div>
          </RevealItem>

          <RevealGroup className="grid gap-6 sm:grid-cols-2 lg:col-span-2">
            {whyUs.map((w) => (
              <RevealItem key={w.title}>
                <div
                  data-testid={`why-card-${w.title.toLowerCase().replace(/\s+/g, "-")}`}
                  className="flex h-full flex-col rounded-2xl border border-line bg-white p-7 shadow-float transition-[transform,box-shadow] duration-300 hover:-translate-y-1.5 hover:shadow-float-lg"
                >
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-sky/15 text-ocean">
                    <Icon name={w.icon} className="h-5 w-5" />
                  </span>
                  <h3 className="mt-5 font-serif text-lg font-semibold text-navy">{w.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-600">{w.desc}</p>
                </div>
              </RevealItem>
            ))}
          </RevealGroup>
        </div>
      </div>
    </section>
  );
}
